import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext, ACTION_TYPES } from '../Context/AppContext';

const SignupComplete = () => {
	const { dispatch } = useAppContext();

	useEffect(() => {
		dispatch({
			type: ACTION_TYPES.SET_PAGE_TITLE,
			payload: { pageTitle: '' },
		});
	}, [dispatch]);

	return <Navigate to="/signup" replace />;
};

export default SignupComplete;
